module.exports = __webpack_public_path__ + "img/banner.2ddd6e96.png";